module.exports = __webpack_public_path__ + "img/sv7.0dd445d0.svg";